const basicNameRegex = /^[a-zA-ZÀ-ÿ\s]+$/;

const nomeRazaoRegex = /^[a-zA-ZÀ-ÿ]+( [a-zA-ZÀ-ÿ]+)+( )*$/;

const removeNonDigits = /\D/g;

const allRepeatedNumbersRegex = /^(?!.*(\d)\1{7})\d+$/;

export {
  basicNameRegex,
  nomeRazaoRegex,
  removeNonDigits,
  allRepeatedNumbersRegex,
};
